(function () {
  // 如果你希望同一时间只展开一个，把这个设为 true；想要多开改为 false
  var SINGLE_OPEN = true;

  var accordions = document.querySelectorAll('.product-accordion');
  if (!accordions.length) return;

  accordions.forEach(function (acc, index) {
    var header = acc.querySelector('.product-accordion-header');
    var panel  = acc.querySelector('.product-accordion-content');
    if (!header || !panel) return;

    // 无障碍属性（不改 HTML 的前提下添加）
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-controls', 'acc-panel-' + index);
    header.setAttribute('aria-expanded', 'false');
    panel.setAttribute('id', 'acc-panel-' + index);
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-hidden', 'true');

    // 监听点击与键盘
    header.addEventListener('click', function () { toggle(acc); });
    header.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle(acc);
      }
    });

    // 过渡结束时把 height 设回 auto，避免后续内容变动卡顿
    panel.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'height') return;
      if (acc.classList.contains('is-open')) {
        panel.style.height = 'auto';
      }
    });
  });

  function toggle(targetAcc) {
    var header = targetAcc.querySelector('.product-accordion-header');
    var panel  = targetAcc.querySelector('.product-accordion-content');
    var isOpen = targetAcc.classList.contains('is-open');


    if (isOpen) {
      closeAcc(targetAcc);
    } else {
      openAcc(targetAcc);
    }

    function openAcc(acc) {
      var p = acc.querySelector('.product-accordion-content');
      var h = acc.querySelector('.product-accordion-header');

      // 先从 0px 开始，再过渡到内容高度
      p.style.height = '0px';
      // 读取一次布局触发 reflow
      p.offsetHeight; 
      var full = p.scrollHeight + 'px';
      p.style.height = full;
      acc.classList.add('is-open');

      // ARIA
      h.setAttribute('aria-expanded', 'true');
      p.setAttribute('aria-hidden', 'false');
    }

    function closeAcc(acc) {
      var p = acc.querySelector('.product-accordion-content');
      var h = acc.querySelector('.product-accordion-header');

      // 如果当前是 auto，先用真实高度锁定，再过渡到 0
      if (getComputedStyle(p).height === 'auto') {
        p.style.height = p.scrollHeight + 'px';
      }
      // 强制读一次高度确保过渡
      p.offsetHeight;
      p.style.height = '0px';

      acc.classList.remove('is-open');

      // ARIA
      h.setAttribute('aria-expanded', 'false');
      p.setAttribute('aria-hidden', 'true');
    }
  }
})();

(function () {
  // ===== 基于你给的逻辑：按钮越过 header 底部时显示粘性表单 =====
  const sticky   = document.querySelector('.product-sticky-form');
  const buttons  = document.querySelector('.product-form__buttons');
  const header   = document.querySelector('.section-header');

  if (!sticky || !buttons || !header) return;

  const EPS = 0; // 显示/隐藏的容差
  function syncSticky() {
    const btnTop       = buttons.getBoundingClientRect().top;
    const headerBottom = header.getBoundingClientRect().bottom;
    const gap = btnTop - headerBottom; // >0 未到；<=0 贴住或越过
    if (gap <= EPS) {
      sticky.removeAttribute('hidden');
    } else {
      sticky.setAttribute('hidden', '');
    }
  }

  // ===== 新增：滚动时根据 120px 偏移高亮导航对应锚点 =====
  const OFFSET   = 120; // 顶部固定 header 的高度
  const MARK_EPS = 6;   // 锚点判定容差（像素抖动）

  const nav      = document.querySelector('.product-nav-menu');
  const navItems = nav ? Array.from(nav.querySelectorAll('.menu-item[nav-id]')) : [];

  // 建立 section（手风琴）与导航项的映射：依据 nav-id="#id"
  const sections = Array.from(document.querySelectorAll('.product-accordion[id]'))
    .map(el => {
      const id   = el.id;
      const link = navItems.find(a => (a.getAttribute('nav-id') || '').replace(/^#/, '') === id);
      return link ? { id, el, link } : null;
    })
    .filter(Boolean);

  function setActive(link) {
    if (!link) return;
    navItems.forEach(a => a.classList.toggle('active', a === link));
  }

  function updateActiveOnScroll() {
    if (!sections.length) return;

    let exact = null, exactDelta = Infinity;
    let bestBelow = null, bestBelowTop = -Infinity;

    for (const s of sections) {
      const top = s.el.getBoundingClientRect().top;
      const delta = Math.abs(top - OFFSET);

      // 1) 优先：与 120px 几乎“对齐”的 section
      if (delta <= MARK_EPS && delta < exactDelta) {
        exact = s; exactDelta = delta;
      }
      // 2) 其次：已经“越过”120px（top <= OFFSET）里，最靠近 120px 的
      if (top <= OFFSET && top > bestBelowTop) {
        bestBelow = s; bestBelowTop = top;
      }
    }

    const chosen = exact || bestBelow || sections[0];
    setActive(chosen.link);
  }

  // 可选：拦截导航点击，带 120px 偏移的平滑滚动
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.product-nav-menu .menu-item[nav-id]');
    if (!a) return;
    const hash = a.getAttribute('nav-id');
    if (!hash || hash === '#') return;
    const id = hash.replace(/^#/, '');
    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    const top = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });

  // ===== 合并到同一个 rAF 节流里 =====
  let ticking = false;
  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      syncSticky();
      updateActiveOnScroll();
      ticking = false;
    });
  }

  // 初次 & 监听
  onScrollOrResize();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  // header 尺寸变化时也更新
  if ('ResizeObserver' in window) {
    new ResizeObserver(onScrollOrResize).observe(header);
  }
})();

  function goTops() {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: 0,
      behavior: prefersReduced ? 'auto' : 'smooth'
    });
  }


  document.querySelectorAll('product-payment-container')
    .forEach(el => el.addEventListener('click', () => {
      document.querySelector('.product-form__submit')?.click();
    }));